import { render, staticRenderFns } from "./OrderListCard.vue?vue&type=template&id=2f2267f9&scoped=true"
import script from "./OrderListCard.vue?vue&type=script&lang=ts"
export * from "./OrderListCard.vue?vue&type=script&lang=ts"
import style0 from "./OrderListCard.vue?vue&type=style&index=0&id=2f2267f9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2267f9",
  null
  
)

export default component.exports